<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 权限管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>角色管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
            <el-card shadow="hover"  class="searchCard" >
                <span class='label-span'>
                    <label class="label">角色名称</label> 
                    <el-input v-model.trim="query.rname" placeholder="角色名称" class="handle-input mr10"></el-input>  
                </span> 
                
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10"  @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10" @click="addBind" >添加角色</el-button>  
   
            </el-card>
            <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" class="table"  ref="multipleTable" header-cell-class-name="table-header"   > 
                <el-table-column prop="rname" min-width="90" align="left" label="角色名称"></el-table-column> 
                <el-table-column prop="rcode" min-width="80" align="left" label="角色类型">
                    <template slot-scope="scope" > 
                        <el-tag :type="scope.row.rtype==1?'primary':'info'">{{scope.row.rtype==1?"管理角色":"普通角色"}}</el-tag>    
                    </template>  
                </el-table-column>  
                <el-table-column prop="rcode" min-width="80" align="left" label="角色编码"> </el-table-column>  
                <el-table-column prop="delFag" min-width="90" align="center" label="状态">
                    <template slot-scope="scope" > 
                         <el-tooltip :content="scope.row.status=='1'?'启用':'关闭'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template>  
                </el-table-column> 
                <el-table-column prop="num" min-width="100" align="center" label="菜单数量"></el-table-column>  
                <el-table-column prop="createTime" min-width="150" align="center" label="创建时间"></el-table-column> 
                <el-table-column label="操作"  min-width="170" align="center" fixed="right">
                    <template slot-scope="scope">  
                        <span class='tableOperBtn' @click="treeShow( scope.row.rcode)" ><i class='el-icon-edit'></i> 菜单权限</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                       
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                       background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50,200]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card>
        
     
        <!-- 新建代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="添加角色" :modal-append-to-body='false' :visible.sync="addPlusVisible" top="80px" width="380px">
            <el-form ref="form1" :model="form1" label-width="90px" @submit.native.prevent="saveForm">  
                <el-form-item label="角色类型" >
                     <el-radio-group v-model.trim="form1.rtype" >
                        <el-radio-button label="1">管理角色</el-radio-button> 
                        <el-radio-button label="2">普通角色</el-radio-button> 
                    </el-radio-group>      
                </el-form-item>  
                <el-form-item label="角色名称" >
                    <el-input  v-model.trim="form1.rname"  placeholder="必填"></el-input>   
                </el-form-item>        
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提交' }}</el-button>
            </span>
        </el-dialog>
  

     
        <!-- 编辑代理渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑角色" :modal-append-to-body='false' :visible.sync="editPlusVisible" top="80px" width="380px">
            <el-form ref="form" :model="form3" label-width="90px"> 
                <el-form-item label="角色类型" >
                     <el-radio-group v-model.trim="form3.rtype" >
                        <el-radio-button label="1">管理角色</el-radio-button> 
                        <el-radio-button label="2">普通角色</el-radio-button> 
                    </el-radio-group>      
                </el-form-item>  
                <el-form-item label="角色编码" >
                    <el-input  v-model.trim="form3.rcode"  placeholder="必填"></el-input>   
                </el-form-item>      
            </el-form>
            <span slot="footer" class="dialog-footer" >
                <el-button @click="editPlusVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
     

        <el-dialog :close-on-click-modal="false" title="绑定菜单" :modal-append-to-body='false' :visible.sync="treeVisible" top="50px" width="360px">
            <div style="height:360px;width:300px;padding:15px;border:1px solid #ddd">
                <div class="over" style="height:360px;overflow-y:scroll;">
                <el-tree
                    class="tree"  
                    ref="tree"
                    :data="treeData"  
                    show-checkbox 
                    node-key="id" 
                    :default-checked-keys="checkData"  
                    :props="defaultProps"
                    highlight-current="true"
                    accordion="true"
                    draggable = "false" 
                ></el-tree>
            </div> 
            </div> 
            <span slot="footer" class="dialog-footer" >
                <el-button @click="treeVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBind">确 定</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus,getTreeData,getCheckData,saveBind} from '../../api/operRole';  
 
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            },
            tableData: [],
            tableData2: [],
            treeData:[],
            showData:[],
            checkData:[],
            multipleSelection: [],
            delList: [],
            rcode:'',
            editVisible: false,
            showVisible:false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            treeVisible:false, 
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                rtype:'1', 
            },
            form2: {   },
            form3: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    }, 
    //页面加载方法
    mounted: function () {
        this.mid = localStorage.getItem('ms_mid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId');  
        this.loginName = localStorage.getItem('ms_username');  
        //查询列表
        this.getData();   
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        treeShow(rcode){   
            this.rcode = rcode;
            this.getTreeData(rcode);  
            this.getCheckData(rcode); 
            this.treeVisible = true;
        },
        treeRefresh(rcode){    
            this.getTreeData(rcode);  
            this.getCheckData(rcode);  
        },
        getTreeData(rcode){
            this.treeData = [];
            let data = {}; 
            data.rcode = rcode;
            getTreeData(data).then(res => {   
                if(res.code=='200'){ 
                    this.treeData = res.data; 
                }
            });
        }, 

        getCheckData(rcode){
            this.showData = [];
            this.checkData = [];
            let data = {}; 
            data.rcode = rcode;
            getCheckData(data).then(res => {   
                if(res.code=='200'){ 
                    this.showData = res.data.showData; 
                    this.checkData = res.data.checkData; 
                }
            });
        }, 

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'rname', '');   
            this.handleSearch();
        }, 
     
        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 
        showIcon(){
            this.showVisible=true;
        },

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
          
        // 新增 
        addBind() {
            this.addPlusVisible = true; 
        },
        //保存新增
        saveForm() {    
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.rname ){
                this.isSubmitting = false;
                this.$message.error("请填写角色名称");
                return;
            } 
            this.loading = true; 
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){ 
                    this.addPlusVisible = false;
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {  
            this.editPlusVisible = true;
            this.form3 = row;   
        },

         
        // 保存更改
        saveBind(){
            var checkedNodes = this.$refs.tree.getCheckedNodes(true);
            var itemIds = "";
            var itemArray = [];
            checkedNodes.forEach(nodes => {
                if(nodes.pid==0){
                    itemArray.push(nodes.id); 
                }else{
                    itemArray.push(nodes.id,nodes.pid);
                } 
            })
            // 利用set没有重复的值这一特性, 实现数组去重。Array.form方法可以将 Set 结构转为数组。
            itemArray = Array.from(new Set(itemArray)) ;
            for(var i=0;i<itemArray.length;i++){ 
                itemIds+=itemArray[i]+",";
            }
            if(itemIds.length>0){
                itemIds = itemIds.substr(0,itemIds.length-1);
            }
            let data = {};
            data.itemIds = itemIds;
            data.rcode = this.rcode; 
            saveBind(data).then(res => {
                if(res.code=='200'){ 
                    this.getData(); 
                    this.treeVisible = false;  
                    this.$message.success(res.message);  
                    localStorage.removeItem(window.location.hostname+'_items');
                }else{
                    this.$message.error(res.message); 
                } 
            });
        },
       

        saveEdit() {  
            this.form3.mid = this.mid;
            this.form3.stationId = this.stationId;  
            if(this.form3.gid==1){
                this.form3.subs="1";
            }else{
                this.form3.subs="";
            }
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.editPlusVisible = false;
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) { 
             let data = {};
            data.id = row.id;
            data.status = row.status;
            data.stationId = this.stationId; 
            data.mid = this.mid; 
            var tips="启用";
            if(row.status==0){
                tips="禁用";
            } 
            changeStatus(data).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(tips+'成功'); 
                    this.getData();
                }else{ 
                    this.$message.error(tips+'失败');
                } 
            }); 
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {    
            // 二次确认删除
            this.$confirm('确定要删除该角色吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
  .label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
</style>

